import classNames from 'classnames'
import TrustpilotItem from 'src/components/shared/TrusPilotItem'

const LoadTrustpilotItem = () => (
  <div className="flex w-full items-center justify-center bg-green-40 py-1 text-center text-14 font-medium lg:bg-white">
    <TrustpilotItem
      starClassName="w-5.5 h-5.5"
      trustpilotRatingClassName="text-14 whitespace-nowrap text-ellipsis overflow-hidden"
      starsGroupClassName="w-20 h-5 mx-2"
      className="my-0 overflow-hidden text-ellipsis"
      shortText
      detailsText
      disableRedirect
      starsGroupImgClassName="pt-1"
    />
  </div>
)

const StickyRender = ({
  linkUrl,
  logo,
  className = {},
  phoneNumber = '800-910-0065',
  lastScrollDirection,
  isBelowStickyThreshold,
  showSticky,
}) => {
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`
  }

  const isVisible =
    lastScrollDirection != 'top' && isBelowStickyThreshold && showSticky

  return (
    <div
      data-testid="sticky-render"
      aria-hidden={!isVisible}
      className={classNames(
        'fixed inset-x-0 top-0 z-100 py-0 shadow-[0_2px_2px_-2px_rgba(0,0,0,0.25)] lg:bg-white lg:py-4',
        'transform-gpu transition-[transform,opacity] duration-500 ease-in-out will-change-transform motion-reduce:transition-none',
        {
          'translate-y-0 opacity-100': isVisible,
          'pointer-events-none -translate-y-full opacity-0': !isVisible,
        },
        className
      )}
    >
      <div className="w-content mx-auto  hidden flex-row items-center justify-between gap-x-5 bg-white lg:flex lg:px-8">
        {logo}
        <p className="whitespace-nowrap text-sm">
          Get credit card debt relief from America’s top debt relief company.
        </p>
        <div className="flex flex-col items-center gap-2">
          <div className="flex flex-row gap-4">
            <button
              onClick={handleCall}
              className="h-12 rounded-md border-2 border-solid border-blue-base bg-white px-5 py-2 text-blue-base"
            >
              <p className="whitespace-nowrap text-heading-4 font-bold text-blue-base">
                Call {phoneNumber}
              </p>
            </button>
            {linkUrl && (
              <a
                href={linkUrl}
                className="group flex h-12 items-center gap-2 rounded-md bg-red-850 px-5 py-2 no-underline"
              >
                <p className="whitespace-nowrap text-heading-4 font-bold text-white">
                  See if you qualify
                </p>
              </a>
            )}
          </div>
          <LoadTrustpilotItem />
        </div>
      </div>
      <div className="mx-auto flex w-full flex-row items-center justify-between gap-x-5 shadow-header lg:hidden lg:px-8">
        <div className="flex w-full flex-col items-center">
          <div className="flex w-full flex-row justify-between gap-4 bg-white px-4 py-2">
            {linkUrl && (
              <a
                href={linkUrl}
                className="group flex h-[45px] min-w-[205px] items-center gap-2 rounded-md bg-red-850 px-5 py-2 no-underline"
              >
                <p className="w-full whitespace-nowrap text-body-medium font-bold text-white">
                  See if you qualify
                </p>
              </a>
            )}
            <button
              onClick={handleCall}
              className="h-[45px] w-full rounded-md border-2 border-solid border-blue-base bg-white px-5 py-2 text-blue-base"
            >
              <p className="whitespace-nowrap text-body-medium font-bold text-blue-base">
                Call Us
              </p>
            </button>
          </div>
          <LoadTrustpilotItem />
        </div>
      </div>
    </div>
  )
}

export default StickyRender
